import { ADJACENT_COURSE_PAUSE_REQUEST_TYPE } from '@courseResume/data/adjacentCoursePauseRequest';

// This function returns the next or previous pause request corresponding to current pause request.
// coursePauseRequests - Array containing course pause requests
// requestId - Current request ID
// actionType - value one of [previous, next]
function getAdjacentPauseRequest(coursePauseRequests, requestId, actionType) {
  if (!coursePauseRequests || !requestId) return null;

  const currentRequestIndex = coursePauseRequests.findIndex(
    (request) => request.id === requestId
  );
  if (
    actionType === ADJACENT_COURSE_PAUSE_REQUEST_TYPE.previous &&
    currentRequestIndex - 1 >= 0
  )
    return coursePauseRequests[currentRequestIndex - 1];
  else if (
    actionType === ADJACENT_COURSE_PAUSE_REQUEST_TYPE.next &&
    currentRequestIndex + 1 < coursePauseRequests.length
  )
    return coursePauseRequests[currentRequestIndex + 1];
  else return null;
}

export default getAdjacentPauseRequest;
